<template>
    <button
        class="menu-item"
        :class="{ 'is-active': isActive ? isActive() : null }"
        @click="action"
        :title="title"
    >
        <svg
            v-svg
            :symbol="icon"
            size="0 0 24 24"
            role="presentation"
        ></svg>
    </button>
</template>

<script lang="ts" setup>
const props = defineProps<{
    icon?: string
    title?: string
    action?: () => boolean
    isActive?: () => boolean
}>()
</script>
